import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      paddingBottom: "13px",
      borderBottom: "1px solid #E0E0E0",
      margin: "24px 0",
    },
    info: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",

      "& h2": {
        fontSize: "17px",
        fontWeight: 400,
        lineHeight: 1,
        margin: 0,
        padding: 0,
        color: "#000",
      },

      "& p": {
        fontSize: "13px",
        fontWeight: 400,
        lineHeight: 1,
        margin: 0,
        padding: 0,
        color: "#707070",
        marginTop: "2px",
      },
    },
  })
);
